import { defineStore } from "pinia";
import { ref } from "vue";

export const useBillsStore = defineStore('useBillsStore', () => {
    const isNeedUpdateBills = ref<boolean>(false);

    return { isNeedUpdateBills };
});
